import { BaseModel } from "sjs-base-model";
import RouteEnum from "constants/RouteEnum";

export default class NavigationStateModel<
    F extends BaseModel | undefined = any,
    C extends BaseModel | undefined = any
> extends BaseModel {
    public readonly origin?: RouteEnum = undefined;
    public readonly originId?: string = undefined;
    public readonly filtri?: F = undefined;
    public readonly parametri?: C = undefined;
    public readonly reload?: boolean = false;

    constructor(data: Partial<NavigationStateModel<F, C>>) {
        super();

        this.update(data);
    }
}
